import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { BooleanInput } from '@angular/cdk/coercion';
import { Subject, takeUntil } from 'rxjs';
import { User } from 'app/core/user/user.types';
import { UserService } from 'app/core/user/user.service';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'user',
  templateUrl: './user.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'user'
})
export class UserComponent implements OnInit, OnDestroy {
  /* eslint-disable @typescript-eslint/naming-convention */
  static ngAcceptInputType_showAvatar: BooleanInput;
  /* eslint-enable @typescript-eslint/naming-convention */

  @Input() showAvatar: boolean = true;
  user: User;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _router: Router,
    private _userService: UserService,
    private translocoService: TranslocoService
  ) {
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {

    this.user = JSON.parse(localStorage.getItem('user'));
    // Subscribe to user changes
    // this._userService.user$
    //     .pipe(takeUntil(this._unsubscribeAll))
    //     .subscribe((user: User) => {
    //         this.user = user;

    //         // Mark for check
    //         this._changeDetectorRef.markForCheck();
    //     });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Update the user status
   *
   * @param status
   */
  updateUserStatus(status: string): void {
    // Return if user is not available
    if (!this.user) {
      return;
    }

    // Update the user
    this._userService.update({
      ...this.user,
      status
    }).subscribe();
  }

  /**
   * Sign out
   */
  signOut(): void {
    localStorage.clear();
    this._router.navigate(['/sign-out']);
  }
  movetoSettings(): void {
    this._router.navigate(['/settings']);
  }
  downloadFile() {
    const currentLang = this.translocoService.getActiveLang();
    let filePath: string;
    switch (currentLang) {
      case 'en':
        filePath = '../../../assets/manuals/Manual-English.pdf';
        break;
      case 'de':
        filePath = '../../../assets/manuals/Manual-Deutsch.pdf';
        break;
      default:
        filePath = '../../../assets/manuals/Manual-English.pdf';
        break;
    }
    // Trigger the file download
    this.download(filePath);
  }

  download(filePath: string) {
    // Create a link element
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', filePath);
    link.setAttribute('download', '');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
